import { LinkAndDocument } from '@/@types'
import { getAxiosErrorMessage } from '@/resources'
import services from '.'

const basePath = '/attachments'

async function getAttachments(): Promise<Array<LinkAndDocument> | undefined> {
  try {
    const attachments = await services.api.get(basePath)
    return attachments.data?.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function create(data: Partial<LinkAndDocument>): Promise<
  | {
      id: string
      uploadUrl: string
    }
  | undefined
> {
  try {
    const attachments = await services.api.post(basePath, data)

    console.log({ attachments })

    return {
      id: attachments.data.data.id,
      uploadUrl: attachments.data.data.uploadURL,
    }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function deleteById(id: string): Promise<void> {
  try {
    await services.api.delete(`${basePath}/${id}`)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default { getAttachments, create, deleteById }
